import { useState } from 'react'
import { SessionStepList, ContentSkeleton } from '../../components/Content/SessionStepList'
import { useUserCourse } from '../../hooks/queries/useUserCourses'
import { useCourseStudyPlan } from '../../hooks/useCourseStudyPlan'
import { useCourseNavigation } from '../../hooks/useCourseNavigation'

export const CourseContentList = ({ slugOrId }: { slugOrId?: string }) => {
    const { courseId, status: courseStatus } = useUserCourse(slugOrId)
    const { plan, status: planStatus } = useCourseStudyPlan(courseId)
    const { navigateToCourse } = useCourseNavigation()
    const [openSession, setOpenSession] = useState<string>()

    if (courseStatus === 'pending' || planStatus === 'pending') return <ContentSkeleton />

    return (
        <>
            {plan?.sessions?.map(session => (
                <SessionStepList
                    key={session.number + session.id}
                    session={session}
                    isFolderOpen={!!openSession}
                    setIsOpen={setOpenSession}
                    onTitleClick={() => slugOrId && navigateToCourse(slugOrId, session.steps?.[0]?.id)}
                />
            ))}
        </>
    )
}
